module.exports = __webpack_public_path__ + "static/media/star.f0867368.svg";